import * as React from 'react';

import {
	StyledHeader,
	Title,
	Toggle,
	ButtonClose,
} from '../styles';
import Utils from '../../../utils';

interface HeaderProps {
	isToastExpanded: boolean;
	onToggle: () => void;
	onClose: () => void;
	isPreparingContentStructure: boolean;
	contentStructureReady: boolean;
	needsContentStructureCompletion?: boolean;
	contentStructureEverCompleted?: boolean;
	isReturnVisitOfflineInit?: boolean;
	isDownloadingRequiredItems?: boolean;
	isDownloadingThumbs?: boolean;
}

const Header = ({
	isToastExpanded,
	onToggle,
	onClose,
	isPreparingContentStructure,
	contentStructureReady,
	needsContentStructureCompletion,
	contentStructureEverCompleted,
	isReturnVisitOfflineInit = false,
	isDownloadingRequiredItems = false,
	isDownloadingThumbs = false,
}: HeaderProps) => {
	let title = '';

	if (needsContentStructureCompletion) {
		// Show "Content structure incomplete" when offline and content was never completed
		title = 'messages.content_structure_incomplete';
	} else if (isPreparingContentStructure) {
		// Show different message for first time vs update
		const isFirstTime = !contentStructureEverCompleted;
		title = isFirstTime ? 'messages.preparing_content_structure' : 'messages.updating_content_structure';
	} else if (isDownloadingRequiredItems) {
		title = 'messages.downloading_required_items_for_offline_use';
	} else if (isDownloadingThumbs) {
		title = isReturnVisitOfflineInit
			? 'messages.verifying_thumbnails_for_offline_use'
			: 'messages.downloading_thumbnails_for_offline_use';
	} else if (contentStructureReady) {
		// Show "Content structure is now available for offline use" when ready and both required items and thumbnails are done
		title = 'messages.content_structure_ready';
	}

	return (
		<StyledHeader>
			<Title
				value={title}
			/>
			<Toggle
				type="button"
				isExpanded={isToastExpanded}
				onClick={onToggle}
			>
				{Utils.getSvgIcon('iconset_down')}
			</Toggle>
			<ButtonClose
				type="button"
				onClick={onClose}
			>
				{Utils.getSvgIcon('iconset_close-2')}
			</ButtonClose>
		</StyledHeader>
	);
};

export default Header;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContentStructureToast/Header/index.tsx